import Input from '../../../common/Input';

export default {
    id: 0,

    name: 'emergency_contacts',
    _system: {
        name: 'Emergency Contacts',
        relatedTo: 'emergency_contacts',
    },

    emergency_name: {
        label: 'Emergency Name',
        hideLabel: true,
        placeholder: 'Add Emergency Name',
        system: {
            component: Input,
            name: 'emergency_name',
            relatedTo: 'emergency_contacts'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'emergency_name',
        rules: {
            title: 'Emergency Name field',
        },
        grid: {
            className: 'col col-7'
        }
    },
    phone: {
        label: 'Emergency Phone',
        hideLabel: true,
        placeholder: 'Add Emergency Phone',
        system: {
            component: Input,
            name: 'phone',
            relatedTo: 'emergency_contacts'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'phone',
        rules: {
            title: 'Emergency Phone field',
        },
        grid: {
            className: 'col col-4'
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/Employee/fields/emergency_contacts.js